import Vue from 'vue'
import orderBy from 'lodash/orderBy'
import intersectionBy from 'lodash/intersectionBy'
import groupBy from 'lodash/groupBy'
import Vuex, { mapState } from 'vuex'
import { Slide } from 'vue-carousel'

import ProjectInclusions from '../../components/Ecoventure/ProjectInclusions'
import ProgrammeList from '../../components/Ecoventure/ProgrammeList'
import ProgrammeDetailModal from '../../components/Ecoventure/ProgrammeDetailModal'
import DesktopBookingWidget from '../../components/Ecoventure/DesktopBookingWidget'
import Responsive from '../../components/core/Responsive'
import TopNav from '../../components/core/TopNav'
import Carousel from '../../components/core/Carousel'
import FooterNav from '../../components/Ecoventure/FooterNav'
import ActivitySummary from '../../components/Ecoventure/ActivitySummary'
import BookingMobile from '../../components/Ecoventure/BookingMobile'

Vue.use(Vuex)
Vue.component('carousel', Carousel)
Vue.component('v-slide', Slide)
Vue.component('responsive', Responsive)
Vue.component('project-inclusions', ProjectInclusions)
Vue.component('programme-list', ProgrammeList)
Vue.component('programme-detail-modal', ProgrammeDetailModal)
Vue.component('desktop-booking-widget', DesktopBookingWidget)
Vue.component('top-nav', TopNav)
Vue.component('footer-nav', FooterNav)
Vue.component('activity-summary', ActivitySummary)
Vue.component('booking-mobile', BookingMobile)

Vue.filter('formatPrice', (rawPrice) => {
  return rawPrice.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
})

$(document).ready(function() {
  initStickySidebar()
})

function initStickySidebar () {
  const bookingWidget = $('.booking-widget-container')

  bookingWidget.stickySidebar({
    topSpacing: 80,
    containerSelector: '.sidebar-sticky-container',
    innerWrapperSelector: '.sidebar__inner'
  })
}

const store = new Vuex.Store({
  state() {
    const searchParams = new URLSearchParams(window.location.search)
    let date = null
    let guests = '0'

    if (searchParams.has('from')) {
      date = moment(searchParams.get('from'), 'YYYY-MM-DD', true)
    }

    if (searchParams.has('guests')) {
      guests = searchParams.get('guests')
    }

    return {
      supplier: null,
      programmes: [],
      activeProgramme: null,
      selectedProgrammes: [],
      isShowingMobileBooking: false,
      formData: {
        date,
        guests
      },
      forceShowDatePicker: false,
      forceShowGuestsPicker: false,
      isSubmitting: false
    }
  },
  getters: {
    ...mapState(['selectedProgrammes']),
    allInclusions (state) {
      let result = null

      for (const pg of state.programmes) {
        if (result === null) {
          result = pg.inclusions
        }
        else {
          result = intersectionBy(result, pg.inclusions, incl => incl.id)
        }
      }

      return orderBy(result, ['order'], ['asc'])
    },
    cartItems (state) {
      return groupBy(state.selectedProgrammes, pg => pg.id)
    }
  },
  mutations: {
    setSupplier (state, supplier) {
      state.supplier = supplier
    },
    setProgrammes (state, programmes) {
      state.programmes = programmes
    },
    setActiveProgramme (state, programme) {
      state.activeProgramme = programme
    },
    addToCart (state, programme) {
      state.selectedProgrammes.push(programme)
    },
    removeFromCart (state, programme) {
      const anyItemIdx = state.selectedProgrammes.findIndex(pg => pg.id === programme.id)

      state.selectedProgrammes.splice(anyItemIdx, 1)
    },
    setIsShowingMobileBooking (state, isShowingMobileBooking) {
      state.isShowingMobileBooking = isShowingMobileBooking
    },
    setMobileFormData (state, { key, value }) {
      state.formData[key] = value
    },
    setForceShowDatePicker (state, forceShowDatePicker) {
      state.forceShowDatePicker = forceShowDatePicker
    },
    setForceShowGuestsPicker (state, forceShowGuestsPicker) {
      state.forceShowGuestsPicker = forceShowGuestsPicker
    }
  },
  actions: {
    fetchSupplierInfo () {
      $.get(`${window.ZUBLU_VARIABLES.ODYSSEY_API}/api/v1/supplier_info?supplier_id=${window.zublu.supplierId}`)
        .done(res => {
          if (res !== 'No Supplier Found') {
            store.commit('setSupplier', res.supplier)
            store.commit('setProgrammes', res.programme)
          }
        })
    },
    doEnquire (context) {
      const { selectedProgrammes, formData } = context.state

      if (formData.date === null) {
        context.commit('setForceShowDatePicker', true)

        return
      }
      if (formData.guests === '0') {
        context.commit('setForceShowGuestsPicker', true)

        return
      }

      this.isSubmitting = true

      const programmesQuantityMap = selectedProgrammes.reduce((agg, programme) => {
        if (typeof agg[programme.id] === 'undefined') {
          agg[programme.id] = 1
        }
        else if (typeof agg[programme.id] === 'number') {
          agg[programme.id] += 1
        }

        return agg
      }, {})

      const urlParams = new URLSearchParams(window.location.search)
      urlParams.set('from_date', formData.date.format('YYYY-MM-DD'))
      urlParams.set('guest_num', formData.guests)
      urlParams.set('id', window.zublu.supplierId)
      urlParams.set('form', 'ecoventure')
      
      for (const pgId in programmesQuantityMap) {
        urlParams.set(pgId, programmesQuantityMap[pgId])
      }

      window.location.href = '/enquiry-direct?' + urlParams.toString()
    }
  }
})

store.dispatch('fetchSupplierInfo')

store.watch((state) => {
  return state.formData
}, (formData) => {
  if (formData.date !== null) {
    store.commit('setForceShowDatePicker', false)
  }
  if (formData.guests !== '0') {
    store.commit('setForceShowGuestsPicker', false)
  }
}, {
  deep: true
})

const apps = document.querySelectorAll('.vue-app')

Array.prototype.forEach.call(apps, el => new Vue({
  el,
  template: el.innerHTML,
  store
}))
